import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useRouteError, useNavigate, isRouteErrorResponse } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  // error が undefined の場合は *ルート経由の404、isRouteErrorResponse で404ステータスも判定
  const is404 = !error || (isRouteErrorResponse(error) && error.status === 404);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        gap: 2,
        p: 4,
      }}
    >
      <Typography variant="h4" color="text.secondary">
        {is404 ? "404" : "エラー"}
      </Typography>
      <Typography variant="h6">
        {is404
          ? "ページが見つかりません"
          : "予期しないエラーが発生しました"}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", maxWidth: 400 }}>
        {is404
          ? "お探しのページは存在しないか、移動した可能性があります。"
          : "操作をやり直すか、ホームに戻ってください。"}
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          前のページに戻る
        </Button>
        <Button variant="contained" onClick={() => navigate("/")}>
          ホームへ
        </Button>
      </Box>
    </Box>
  );
}
